import { getEmployeesTaetigkeiten } from './getEmployeesTaetigkeiten.js';
import { getEmployeesWithTaetigkeit } from './getEmployeesWithTaetigkeit.js';

export namespace EmployeeAPI {
  export const getWithTaetigkeit = getEmployeesWithTaetigkeit;
  export const getTaetigkeiten = getEmployeesTaetigkeiten;
}
